import { makeStyles } from '@material-ui/core/styles';
import { DisabledVariant } from './index';

type CheckboxFieldProps = {
  disabledVariant: DisabledVariant;
  bordered: boolean;
};

export const useStyles = makeStyles(theme => ({
  authInputField: {
    position: 'relative',

    '& .MuiFormHelperText-root.Mui-error': {
      position: 'absolute',
      bottom: theme.spacing(-10),
    },
  },
  input: {
    color: '#2D2D2D',
    padding: theme.spacing(10, 11.5, 10.5),
    backgroundColor: '#fff',
    borderRadius: theme.spacing(2.5),
    transition: theme.transitions.create(['background-color', 'box-shadow']),

    '&::placeholder': {
      font: 'normal normal normal 14px/18px Roboto',
      color: '#C4C4C4',
      opacity: 1,
    },

    '&:focus': {
      backgroundColor: '#fff',
      boxShadow: '0px 5px 10px #E0E4EE',
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(6),
      lineHeight: '14px',
      padding: theme.spacing(7.5, 8),
    },
  },
  label: {
    display: 'flex',
    fontWeight: 400,
    fontSize: theme.spacing(7),
    lineHeight: '18px',
    color: '#000000',
    paddingBottom: theme.spacing(3),
    letterSpacing: 0,

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(4.5),
      lineHeight: '11px',
    },
  },
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
  disabled: {
    backgroundColor: ({ disabledVariant }: CheckboxFieldProps) => (disabledVariant === 'grey' ? '#C5C5C5' : 'unset'),
  },
}));
